import { FC } from 'react';
import classnames from 'classnames';
import { Checkbox, Switch } from '../uiLibraryImports';
import { useTranslationContext } from '../contexts/translationContext';
import { EmailNotificationsProps } from './emailNotificationsTypes';
import styles from './emailNotifications.module.scss';

const EmailNotifications: FC<EmailNotificationsProps> = (props: EmailNotificationsProps) => {
    const {
        subscribeToNotificationsEmails,
        isSubscribeToNotificationsEmailsDisabled,
        subscribeToProgressEmails,
        isSubscribeToProgressEmailsDisabled,
        setSubscribeToNotificationsEmails,
        setSubscribeToProgressEmails
    } = props;
    const { translate } = useTranslationContext();
    return (
        <div className={styles['notifications-wrapper']}>
            <div
                className={classnames(styles['email-notifications-wrapper'], {
                    [styles['unsubscribed-nofitications']]: !subscribeToNotificationsEmails
                })}
            >
                <div>{translate('EmailNotifications')}</div>
                <div className={styles['email-switch']}>
                    <Switch
                        checked={subscribeToNotificationsEmails}
                        onChange={event => setSubscribeToNotificationsEmails(event.target.checked)}
                        disabled={isSubscribeToNotificationsEmailsDisabled}
                    />
                </div>
            </div>
            <div
                className={classnames(styles['email-progress-notifications-wrapper'], {
                    [styles['unsubscribed-nofitications']]: !subscribeToNotificationsEmails
                })}
            >
                <Checkbox
                    className={classnames(styles.checkbox, {
                        [styles['disabled-checkbox']]: !subscribeToNotificationsEmails
                    })}
                    disabled={
                        !subscribeToNotificationsEmails ||
                        isSubscribeToProgressEmailsDisabled ||
                        isSubscribeToNotificationsEmailsDisabled
                    }
                    size="small"
                    checked={subscribeToProgressEmails}
                    onChange={event => setSubscribeToProgressEmails(event.target.checked)}
                />
                <div>{translate('MonthlyProgressReminders')}</div>
            </div>
        </div>
    );
};

export default EmailNotifications;
